import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { SUBMIT_CODE, REQUEST_PHARMACY_CHANGE } from '../../queries/mutations';
import useMakeScrollable from "custom_hooks/make-scrollable";
import closeIcon from "../../assets/images/close_icon.png";
import Button from 'ui-components/button';

const ProfilePharmacyModal = ({ showBanner, setShowBanner, setHasRequestedChange }) => {
  const [registrationCode, setRegistrationCode] = useState('');
  const [errorMessage, setErrorMessage] = useState();
  const [pharmacy, setPharmacy] = useState();

  useMakeScrollable();

  const [submitCode] = useMutation(SUBMIT_CODE, {
    onCompleted: data => {
      setErrorMessage(null);
      setPharmacy(data.submitRegistrationCode.pharmacy);
    },
    onError: data => {
      setErrorMessage('Code nicht korrekt');
    },
  });

  const [requestPharmacy] = useMutation(REQUEST_PHARMACY_CHANGE, {
    onCompleted: () => {
      setHasRequestedChange(true);
      setShowBanner(false);
    },
    onError: (error) => {
      console.error('GraphQL Error:', error);
      setErrorMessage('Etwas ist schief gelaufen');
    },
  });

  const handleRegistrationCodeChange = e => {
    setRegistrationCode(e.target.value);
  };

  const checkCode = () => {
    submitCode({
      variables: {registrationCode: registrationCode},
    });
  };

  const requestPharmacyChange = () => {
    const isoDate = new Date().toISOString().split('T')[0];
    requestPharmacy({
      variables: {
        pharmacyId: pharmacy.id,
        startDate: isoDate,
      },
    });
  };

  if (!showBanner) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-profile-container">
        <div 
          className="modal-closeButton"
          onClick={() => setShowBanner(false)}
        >
          <img src={closeIcon} alt="Close" />
        </div>

        {!pharmacy ? (
          <div className="profile-code">
            <div className="profile-code-title">Um deine Apotheke zu aktualisieren, bitte füge hier die BGA Nummer deiner aktuellen Apotheke ein.</div>
            <input
              name="registration_code"
              className="login-box-input"
              placeholder="Ihr Code"
              onChange={handleRegistrationCodeChange}
            />
            {errorMessage && (
              <div className="error-message">{errorMessage}</div>
            )}
            <div className="profile-code-button">
              <Button onClick={checkCode} profile={true}>
                Weiter
              </Button>
            </div>
          </div>
        ) : (
          <div className="profile-code">
            <div className="profile-code-title">Ihre Apotheke:</div>
            <div className="profile-pharmacy-name">{pharmacy.name}</div>
            <div className="profile-code-button">
              <Button 
                onClick={requestPharmacyChange} 
                profile={true}
              >
                Absenden
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfilePharmacyModal;
